<template>
  <v-sheet
    rounded
    class="pa-4"
    @mouseover="hover = true"
    @mouseout="hover = false"
    :border="hover"
    style="border: 2px solid transparent"
    :style="{ borderColor: hover ? 'rgba(var(--v-border-color), var(--v-border-opacity))' : 'transparent' }"
  >
    <b class="text-h6 text-md-h5 mb-4 d-flex">
      <v-avatar
        :color="numColor"
        class="mr-3"
        size="x-small"
      >
        <div class="text-body-2">{{ num }}</div>
      </v-avatar>

      <span>{{ title }}</span>
    </b>

    <template v-if="description">
      {{ description }}
    </template>
    <slot />
  </v-sheet>
</template>

<script
  setup
  lang="ts"
>
const props = defineProps<{
  num: number|string;
  title: string;
  description?: string;
}>();

const hover = ref(false);
const numColor = computed(() => hover.value ? 'info' : 'blue-grey-lighten-2');
</script>
